(function(){
  if(window.__lpInit) return;
  window.__lpInit = true;

  function init(){
    /* Product card variant/size radios + FORCED direct checkout */
    document.querySelectorAll('.lp__form').forEach(function(form){
      var idInput = form.querySelector('[data-lp-id]');
      var card = form.closest('.lp__card');
      var priceEl = card ? card.querySelector('[data-lp-price]') : null;
      var compareEl = card ? card.querySelector('[data-lp-compare]') : null;
      form.querySelectorAll('input[type=radio]').forEach(function(r){
        r.addEventListener('change', function(){
          if(idInput) idInput.value = r.value;
          if(priceEl && r.dataset.price) priceEl.textContent = r.dataset.price;
          if(compareEl){ compareEl.textContent = (r.dataset.compare && r.dataset.compare !== r.dataset.price) ? r.dataset.compare : ''; }
        });
      });

      form.addEventListener('submit', function(e){
        e.preventDefault();
        e.stopPropagation();
        var id = idInput ? idInput.value : null;
        if(!id) return;
        var qtyEl = form.querySelector('[name="quantity"]');
        var qty = qtyEl ? (parseInt(qtyEl.value,10) || 1) : 1;
        var btn = form.querySelector('button[type=submit]');
        if(btn){ btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Processing...'; }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(id,10), quantity: qty }] })
        }).then(function(){
          window.location.href = '/checkout';
        }).catch(function(){
          window.location.href = '/checkout';
        });
      }, true);
    });

    /* FAQ accordion */
    document.querySelectorAll('.lp__q-btn').forEach(function(btn){
      btn.addEventListener('click', function(){
        var q = btn.closest('.lp__q');
        var a = q.querySelector('.lp__q-a');
        var open = q.classList.toggle('is-open');
        a.style.maxHeight = open ? (a.scrollHeight + 'px') : '0px';
      });
    });

    /* Countdown (optional announcement) */
    document.querySelectorAll('[data-lp-countdown]').forEach(function(cd){
      var mins = parseInt(cd.getAttribute('data-mins'),10) || 15;
      var key = 'lp_cd_' + mins;
      var end = parseInt(sessionStorage.getItem(key),10);
      if(!end || isNaN(end) || end < Date.now()){ end = Date.now() + mins*60000; sessionStorage.setItem(key, end); }
      var h=cd.querySelector('[data-h]'), m=cd.querySelector('[data-m]'), s=cd.querySelector('[data-s]');
      function pad(n){return (n<10?'0':'')+n;}
      function tick(){
        var d=Math.max(0,end-Date.now()), t=Math.floor(d/1000);
        if(h) h.textContent=pad(Math.floor(t/3600));
        if(m) m.textContent=pad(Math.floor((t%3600)/60));
        if(s) s.textContent=pad(t%60);
        if(d<=0){ end=Date.now()+mins*60000; sessionStorage.setItem(key,end); }
      }
      tick(); setInterval(tick,1000);
    });
  }

  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();
